import { Category } from '../../../domain/models/category.models';

import { isNoindexCategory } from './is-no-index-category.use-case';

import { NoIndexConfiguration } from '@core/domain/models/seo.models';

/**
 * Check if country/lang or category should have noindex
 *
 * @param countryCode Country code
 * @param languageCode Language code
 * @param defaultLanguageCode Default language code
 * @param category Category
 *
 * @returns True if country/lang or category should have noindex
 */
export function checkNoindex(
    seoConfig: NoIndexConfiguration,
    countryCode: string,
    languageCode: string,
    defaultLanguageCode: string,
    category?: Category,
): boolean {
    const hasNoIndexCountryLang = Object.hasOwn(seoConfig.noindexCountryLangs, countryCode)
    && (seoConfig.noindexCountryLangs[countryCode].length === 0
        || seoConfig.noindexCountryLangs[countryCode].some(
            lang => lang === languageCode,
        ));

    // Case 2: Secndary languages without exceptions
    const langShouldHaveNoindex = defaultLanguageCode !== languageCode
    && !seoConfig.noindexExcludedCountries?.some(
        country => country === countryCode,
    );

    // Case 3: If it's category and has attachment noindex
    const hasNoIndexAttachment = isNoindexCategory(category?.attachments);

    return langShouldHaveNoindex || hasNoIndexAttachment || hasNoIndexCountryLang;
}
